import { useCallback, useState } from "react"

import { toast } from "react-toastify"

import { useApiObservableHandler } from "./useApiObservableHandler"
import AuthFormProcessObservable from "../OrderResults/AuthForm"

interface SendAuthFormByPhoneProps {
  emailAddress: string[]
  formFoxTestAN: number
  personId: number
  vendorId: number
  callback?: (response?: string) => void
}

interface UseAuthFormProcessTextProps {
  showSuccess?: boolean
}

function useAuthFormProcessText({ showSuccess = true }: UseAuthFormProcessTextProps = {}) {
  const [processing, setProcessing] = useState(false)
  const [response, setResponse] = useState("")

  const handleApi = useApiObservableHandler<string>()

  const handleOnSuccess = useCallback(
    (result: string, callback?: (result?: string) => void) => {
      if (showSuccess) {
        toast.success(result)
      }
      callback?.(result)
    },
    [showSuccess]
  )

  const sendAuthFormByPhone = useCallback(
    ({ emailAddress, formFoxTestAN, personId, vendorId, callback }: SendAuthFormByPhoneProps) => {
      return handleApi({
        observableFactory: () =>
          AuthFormProcessObservable({
            EmailAddress: emailAddress,
            FormFoxTestAN: formFoxTestAN,
            PersonID: personId,
            VendorID: vendorId,
            SendToEmail: false,
            SendText: true,
          }),
        onSuccess: (result: string) => handleOnSuccess(result, callback),
        onLoadingChange: setProcessing,
        setResponse,
        defaultSuccessMessage: "Text sent successfully.",
      })
    },
    [handleApi, handleOnSuccess]
  )

  return {
    processing,
    response,
    sendAuthFormByPhone,
  }
}

export default useAuthFormProcessText
